export default "__VITE_ASSET__CzIwROU5__"